import LayoutBasic from '@/layouts/basic'

const meta = {
  auth: true,
}

const pre = 'floating-'

export default {
  path: '/floating',
  name: 'floating',
  redirect: {
    name: `${pre}list`,
  },
  meta,
  component: LayoutBasic,
  children: [
    {
      path: 'list',
      name: `${pre}list`,
      meta: {
        ...meta,
        title: '首页悬浮',
      },
      component: () => import('@/views/floating/list'),
    },
  ],
}
